var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-6" }, [
          _c(
            "div",
            [
              _c("h3", { staticClass: "mb-4" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("watches.title_default")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("ChannelSelectGroup", {
                staticClass: "mb-5",
                model: {
                  value: _vm.watches.default,
                  callback: function ($$v) {
                    _vm.$set(_vm.watches, "default", $$v)
                  },
                  expression: "watches.default",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6" }, [
          _c("div", [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-4" },
              [
                _c("h3", { staticClass: "m-0" }, [
                  _vm._v(_vm._s(_vm.$t("watches.title_shifts"))),
                ]),
                _vm._v(" "),
                _c("BFormCheckbox", {
                  staticClass: "ml-auto",
                  staticStyle: {
                    "margin-top": "-0.3125rem",
                    "margin-right": "-.5em",
                  },
                  attrs: {
                    name: "active-watches",
                    switch: "",
                    "aria-label": _vm.$t("watches.active_watch"),
                    size: "lg",
                    disabled: !_vm.isActiveShiftDisabled,
                  },
                  model: {
                    value: _vm.value.shifts_active,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "shifts_active", $$v)
                    },
                    expression: "value.shifts_active",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              !_vm.isActiveShiftDisabled
                ? _c("div", {
                    staticClass: "alert alert-warning mb-4",
                    domProps: {
                      textContent: _vm._s(_vm.$t("watches.no_pro_licences")),
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "mt-4",
                style: { opacity: _vm.watches.shifts_active ? 1 : 0.5 },
              },
              [
                _c(
                  "div",
                  { staticClass: "mb-4" },
                  [
                    _c("TimezoneEditor", {
                      model: {
                        value: _vm.value.timezone,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "timezone", $$v)
                        },
                        expression: "value.timezone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-4" },
                  [
                    _c(
                      "Button2",
                      {
                        attrs: { disabled: !_vm.watches.shifts_active },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleAddShift($event)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-plus",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("watches.add_shift")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.shiftCount
                  ? _c("div", { staticClass: "mb-4 text-center" }, [
                      _c("div", {
                        staticClass: "alert alert-info",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("watches.empty_shifts")),
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "draggable",
                  {
                    attrs: {
                      list: _vm.watches.shifts,
                      handle: ".handle",
                      "ghost-class": "ghost",
                    },
                    on: {
                      start: function ($event) {
                        _vm.dragging = true
                      },
                      end: function ($event) {
                        _vm.dragging = false
                      },
                    },
                  },
                  _vm._l(_vm.watches.shifts, function (shift, index) {
                    return _c("ShiftCardCompact", {
                      key: shift.id,
                      staticClass: "mb-1",
                      attrs: { value: shift },
                      on: {
                        "active-change": _vm.handleShiftActiveChange,
                        "edit-shift": function ($event) {
                          return _vm.openEditShiftModal(index)
                        },
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("BasicModal", {
        ref: "createShiftModal",
        attrs: { title: _vm.$t("watches.addShift"), size: "xl" },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("ShiftForm", {
                  attrs: { proLicences: _vm.isActiveShiftDisabled },
                  on: {
                    "edit-shift": function ($event) {
                      return _vm.handleUpdateShift(_vm.shiftInEditModal)
                    },
                  },
                  model: {
                    value: _vm.shiftInEditModal,
                    callback: function ($$v) {
                      _vm.shiftInEditModal = $$v
                    },
                    expression: "shiftInEditModal",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c(
                      "Button2",
                      {
                        staticClass: "btn-brand ml-auto",
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleCreateShift(_vm.shiftInEditModal)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("global.add")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("BasicModal", {
        ref: "editShiftModal",
        attrs: { title: _vm.$t("watches.editShift"), size: "xl" },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("ShiftForm", {
                  attrs: {
                    proLicences: _vm.useDvFlagAccess("beepiz-shift-can:read"),
                  },
                  on: {
                    "edit-shift": function ($event) {
                      return _vm.handleUpdateShift(_vm.shiftInEditModal)
                    },
                  },
                  model: {
                    value: _vm.shiftInEditModal,
                    callback: function ($$v) {
                      _vm.shiftInEditModal = $$v
                    },
                    expression: "shiftInEditModal",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-row-reverse",
                    staticStyle: { gap: "1rem" },
                  },
                  [
                    _c(
                      "Button2",
                      {
                        staticClass: "btn-brand",
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleUpdateShift(_vm.shiftInEditModal)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("global.validate")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "Button2",
                      {
                        staticClass: "btn-danger",
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleDeleteShift(
                              _vm.shiftIndexInEditModal
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("global.delete")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }